import React from "react";

const ContactUs = () => {
	return (
		<div className="section">
			<h4>CONTACT US</h4>
			<p>Kevin Suits, Naalya Namugongo, Kampala </p>
			<p>
				<a className="tel" href="tel:+256 784 228409">
					+256 784 228409 | +256 393 243 341
				</a>
			</p>

			<p className="email">
				<a href="mailto: info@enact.ug">info@enact.ug</a>
			</p>
		</div>
	);
};

export default ContactUs;
